module.exports = __webpack_public_path__ + "img/logofinadi.b8060d3a.png";